import React, { Fragment } from "react";
//import classes from "./Video.module.css";

const Video = (props) => {
  return (
    <Fragment>
      <video controls width={props.width}>
        <source
          src={props.src}
          type={props.type}
        />
        <source
          src="https://www.marchouben.nl/video/file-480-900kB.webm"
          type='video/webm; codecs="vp8, vorbis"'
        />
        Sorry, your browser doesn't support embedded videos.
      </video>
    </Fragment>
  );
};

export default Video;
